// Shared listening pages and the chat panel use signed playback assets without
// requiring access to the creator's private library or original session.
export const isPreviewPlayer = () => typeof window !== 'undefined' && (
  window.__COOKUP_CHAT_PLAYER__ || /^\/share\/[A-Za-z0-9_-]{32}\/?$/.test(window.location.pathname)
);
